import { useState } from "preact/hooks";
import type { ProjectDto } from "@shared/types";
import { api } from "../../lib/api-client";
import { useToast } from "../../lib/use-toast";
import {
  Alert,
  Button,
  Card,
  CardBody,
  Field,
  Input,
  SectionHeading,
} from "../ui";

export function ProjectMetadataSection({
  project,
  onProjectUpdate,
}: {
  project: ProjectDto;
  onProjectUpdate: (project: ProjectDto) => void;
}) {
  const [name, setName] = useState(project.name);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const toast = useToast();

  async function onSubmit(e: Event) {
    e.preventDefault();
    const normalized = name.trim();
    if (!normalized || normalized === project.name) return;
    setSaving(true);
    setError(null);
    try {
      const updated = await api.updateProject(project.id, { name: normalized });
      setName(updated.name);
      onProjectUpdate(updated);
      toast.success("プロジェクト名を更新しました。");
    } catch (e) {
      setError((e as Error).message);
    } finally {
      setSaving(false);
    }
  }

  return (
    <div class="space-y-4">
      <SectionHeading level={3} title="基本設定" />
      <Card>
        <CardBody>
          <form onSubmit={onSubmit} class="grid gap-4 sm:grid-cols-2">
            <Field label="プロジェクト名" required>
              <Input
                value={name}
                required
                maxLength={120}
                onInput={(e) => setName((e.currentTarget as HTMLInputElement).value)}
              />
            </Field>
            <Field label="slug" hint="公開URLとR2キーに使うため画面からは変更できません">
              <Input value={project.slug} disabled class="font-mono" />
            </Field>
            <div class="flex justify-end sm:col-span-2">
              <Button
                type="submit"
                variant="primary"
                loading={saving}
                disabled={saving || !name.trim() || name.trim() === project.name}
              >
                {saving ? "保存中…" : "名前を保存"}
              </Button>
            </div>
          </form>
          {error && (
            <Alert tone="danger" class="mt-4">
              {error}
            </Alert>
          )}
        </CardBody>
      </Card>
    </div>
  );
}
